import { useEffect } from 'react';
import { create } from 'zustand';

export interface FocusedWidget {
  id: string;
  name: string;
}

interface CopilotRequests {
  /** The widget the person has open, which each Flow.Assist turn names. */
  focusedWidget: FocusedWidget | null;
  /** A prompt for Flow.Assist's composer; `id` tells a repeated request from the last one. */
  prefill: { text: string; id: number } | null;
  /** The last prefill's id, kept after it is used, so the next request is never mistaken for it. */
  requests: number;
  /** Puts a prompt in Flow.Assist's composer, such as the start of a request for a new widget. */
  ask: (prompt: string) => void;
  clearPrefill: () => void;
}

/** What the builder asks of Flow.Assist from outside its panel, and the widget its turns name. */
export const useCopilotRequests = create<CopilotRequests>((set) => ({
  focusedWidget: null,
  prefill: null,
  requests: 0,
  ask: (prompt) =>
    set((state) => ({
      prefill: { text: prompt, id: state.requests + 1 },
      requests: state.requests + 1,
    })),
  clearPrefill: () => set({ prefill: null }),
}));

/** Clears the requests when the screen that made them closes: the store outlives it. */
export function useForgetCopilotRequestsOnLeave(): void {
  useEffect(
    () => () => {
      useCopilotRequests.setState({ focusedWidget: null, prefill: null });
    },
    [],
  );
}
